/*
  Custom source key to svg name mapping required for Google Ads,
  since google_ads.svg is seemingly reserved in some Google Chrome
  browser versions, leading to broken svg rendering.
 */
export const SOURCE_IMAGE_CUSTOM_MAPPINGS = {
  google_ads: 'g_ads',
};
